export default __webpack_public_path__ + "static/media/Awards_BG-03.07167974.png";